import { useCallback } from 'react';
import { useEntriesQuery } from '../services/entries/entries.service';

export function useEntries(id?: number) {
  const { data: entries, error: entriesError, refetch, isLoading } = useEntriesQuery(id);

  const ensureData = useCallback(async () => {
    if (entries) {
      return entries; // Return immediately if we have cached data
    }

    if (entriesError) {
      throw new Error('Eroare la preluarea datelor legate de intrari');
    }

    const result = await refetch();
    return result.data;
  }, [id, refetch]);

  return {
    entriesError,
    isLoading,
    ensureData,
  };
}
